import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { installGlobalDiagHandlers } from "@/utils/diag";
import { installAudioUnlock } from "@/audio/auctioneerAudio";

// [DIAG] Cross-environment breadcrumbs. Installed before render so a crash
// during the first paint is still captured.
installGlobalDiagHandlers();
// Adam's audio element unlocks on the first gesture in ANY tab, so a tab that
// never ran an explicit prewarm cannot go permanently silent (or strand a
// ceremony awaiting a clip that will never play).
installAudioUnlock();

// [Phase 2a.2-C §5.3] Sentry init - fails open if DSN unset.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [],
    tracesSampleRate: 0.1,
    environment: process.env.REACT_APP_PGF_DEPLOY_MODE || "admin_test",
    // Privacy: drop any event data that looks like a raw password/token.
    beforeSend(event) {
      try {
        if (event.request?.headers) {
          const h = event.request.headers;
          for (const k of Object.keys(h)) {
            if (["authorization", "cookie"].includes(k.toLowerCase())) {
              h[k] = "[redacted]";
            }
          }
        }
      } catch {
        // best-effort
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const Wrapped = sentryDsn
  ? () => (
      <Sentry.ErrorBoundary fallback={<p>Something went wrong. Reload the page.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    )
  : () => <App />;

root.render(
  <React.StrictMode>
    <Wrapped />
  </React.StrictMode>,
);
